import { render } from "./PopupVideo.vue?vue&type=template&id=2f91a05a&scoped=true"
import script from "./PopupVideo.vue?vue&type=script&lang=js"
export * from "./PopupVideo.vue?vue&type=script&lang=js"

import "./PopupVideo.vue?vue&type=style&index=0&id=2f91a05a&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f91a05a"]])

export default __exports__